import '../styles.scss'
import '../responsive.scss'

import React, { useEffect } from 'react'

import ReportFooter from '@/components/models/report/footer/footer'
import ReportHeader from '@/components/models/report/header/header'
import { setStoredUTMParams } from '@/utils/analytics'

type Props = {
  shareButtonsScrollTop?: number
  location: Location
  children: React.ReactNode
}
const LayoutReport: React.FC<Props> = ({ location, children }) => {
  const isRootPath = location?.pathname === '/'

  useEffect(() => {
    setStoredUTMParams(location)
  }, [location])

  return (
    <div className="global-wrapper" data-is-root-path={isRootPath}>
      <ReportHeader />
      <main className="main-content">{children}</main>
      <ReportFooter />
    </div>
  )
}

export default LayoutReport
